import { render } from "./form-users.vue?vue&type=template&id=ef5a4dec&ts=true"
import script from "./form-users.vue?vue&type=script&lang=ts"
export * from "./form-users.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__